import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, StarIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-8 px-4 overflow-hidden" data-id="element-91">
      {/* Radial Glow Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(10,42,255,0.15)_0%,rgba(13,13,13,1)_60%)] pointer-events-none" data-id="element-92" />

      <div className="max-w-4xl mx-auto w-full flex flex-col items-center relative z-10" data-id="element-93">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 bg-electric-blue/10 border border-electric-blue/30 text-electric-blue px-4 py-1.5 rounded-full text-sm font-medium mb-8" data-id="element-94">
          <LockIcon className="w-4 h-4" data-id="element-95" />
          <span data-id="element-96">+4.800 personas ya saben lo que los demás ocultan</span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-10 text-center" data-id="element-97">
          Leé lo que
          <br data-id="element-98" />
          <span className="text-smoke/70" data-id="element-99">nadie te dice.</span>
          <br data-id="element-100" />
          Detectá lo que
          <br data-id="element-101" />
          <span className="text-electric-blue" data-id="element-102">todos ocultan.</span>
        </motion.h1>

        {/* Product Image — right after headline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mb-10" data-id="element-103">
          <div className="absolute -inset-8 bg-electric-blue/20 blur-[60px] rounded-full pointer-events-none" data-id="element-104" />
          <img src="https://cdn.magicpatterns.com/uploads/4fA3L9gwwrqypbCgeT2b5A/heylloyd-image-1773680555106.png" alt="El Lector de Mentes — Pack Completo de 6 Tomos PDF" className="relative z-10 w-[280px] md:w-[340px] lg:w-[380px] h-auto rounded-xl shadow-[0_0_40px_rgba(10,42,255,0.3),0_0_80px_rgba(201,168,76,0.15)] border border-gold/20" data-id="element-105" />

          {/* Floating star badge */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-deep-black/80 backdrop-blur-md border border-gold/30 px-4 py-2.5 rounded-xl shadow-lg flex items-center gap-3 z-20 whitespace-nowrap" data-id="element-106">
            <div className="flex text-gold" data-id="element-107">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-gold" data-id="element-108" />)}
            </div>
            <span className="text-sm font-medium text-white" data-id="element-109">
              +4.800 lectores
            </span>
          </motion.div>
        </motion.div>

        {/* Description */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-lg md:text-xl text-smoke/80 mb-8 max-w-xl leading-relaxed text-center" data-id="element-110">
          El pack de 6 tomos PDF que te enseña a leer microexpresiones, detectar
          mentiras en tiempo real y protegerte de manipuladores — sin ser
          psicólogo ni adivino.
        </motion.p>

        {/* CTA */}
        <motion.a initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} href="#checkout" className="w-full sm:w-auto bg-electric-blue text-white font-heading font-bold text-lg md:text-xl px-8 py-4 rounded-lg shadow-glow-blue hover:bg-blue-600 transition-all transform hover:scale-105 text-center flex items-center justify-center gap-3 animate-pulse-glow" data-id="element-111">
          <span data-id="element-112">👁️</span> DESCUBRÍ LO QUE OTROS NO VEN
        </motion.a>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-6 text-sm text-smoke/60 font-medium" data-id="element-113">
          <span className="flex items-center gap-1" data-id="element-114">
            <CheckIcon className="w-4 h-4 text-gold" data-id="element-115" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-116">
            <CheckIcon className="w-4 h-4 text-gold" data-id="element-117" /> 100% digital
          </span>
          <span className="flex items-center gap-1" data-id="element-118">
            <CheckIcon className="w-4 h-4 text-gold" data-id="element-119" /> Garantía de 7 días
          </span>
        </motion.div>
      </div>
    </section>;
}